import { put, call } from 'redux-saga/effects';
import { affiliateProfileList, affiliateCompanyInfoAdd, affiliateCompanyInfoUpdate, affiliateAddressUpdate,affiliatePrimaryContactUpdate,affiliateSettingsUpdate,affiliateProfileEdit,affiliateDelete } from '../services/affiliateService';

import * as types from '../actions';


export function* affiliateProfileListSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(affiliateProfileList, payload);
    yield put({ type: types.AFFILIATES_LIST_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.AFFILIATES_LIST_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* affiliateCompanyInfoAddSaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(affiliateCompanyInfoAdd, payload);
      yield put({ type: types.AFFILIATE_COMPANYINFO_ADD_SUCCESS, response })
            
    } catch(error) {
      yield put({ type: types.AFFILIATE_COMPANYINFO_ADD_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
    }
}

export function* affiliateProfileEditSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(affiliateProfileEdit, payload);
    yield put({ type: types.AFFILIATE_EDIT_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.AFFILIATE_EDIT_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
    }
}

export function* affiliateCompanyInfoUpdateSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(affiliateCompanyInfoUpdate, payload);
    yield put({ type: types.AFFILIATE_CMPNY_INFO_UPDATE_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.AFFILIATE_CMPNY_INFO_UPDATE_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
    }
}

export function* affiliateAddressUpdateSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(affiliateAddressUpdate, payload);
    yield put({ type: types.AFFILIATE_ADDRESS_UPDATE_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.AFFILIATE_ADDRESS_UPDATE_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
    }
}

export function* affiliatePrimaryContactUpdateSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(affiliatePrimaryContactUpdate, payload);
    yield put({ type: types.AFFILIATE_PRMRY_CNT_UPDATE_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.AFFILIATE_PRMRY_CNT_UPDATE_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
    }
}

export function* affiliateSettingsUpdateSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(affiliateSettingsUpdate, payload);
    yield put({ type: types.AFFILIATE_SETTINGS_UPDATE_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.AFFILIATE_SETTINGS_UPDATE_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* affiliateDeleteSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(affiliateDelete, payload);
    yield put({ type: types.AFFILIATE_DELETE_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.AFFILIATE_DELETE_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
} 

